import apis from '../../service/apis/couponGroupApi'
export const teamManage = {
  namespaced: true,
  state: {
    teamData: [],
    total: 0,
    createGroupMemberSuccess: false,
    removeGroupMemberSuccess: false,
    tableLoading: true
  },
  mutations: {
    updateTeamData (state, payload) {
      const {dataList, total} = payload.res.data
      state.teamData = dataList
      state.total = total
      state.tableLoading = false
    },
    createGroupMemberSuccess (state, payload) {
      state.createGroupMemberSuccess = payload.res
    },
    removeGroupMemberSuccess (state, payload) {
      state.removeGroupMemberSuccess = payload.res
    },
    openLoading (state) {
      state.tableLoading = true
    }
  },
  actions: {
    getAllMember ({ commit }, params) {
      apis.getAllMember(params).then(res => {
        commit('updateTeamData', {res})
      })
    },
    createGroupMember ({ commit }, params) {
      console.log(params)
      apis.createGroupMember(params).then(res => {
        commit('createGroupMemberSuccess', {res})
      })
    },
    removeGroupMember ({ commit }, params) {
      apis.removeGroupMember(params).then(res => {
        commit('removeGroupMemberSuccess', {res})
      })
    }
  }
}
